import { mapGetters } from 'vuex';

import reportCommentsItem from './reportCommentsItem/index.vue';
import reportCommentsForm from './reportCommentsForm/index.vue';

import buttonLoader from '@/components/button';
import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

export default {
  components: {
    reportCommentsItem,
    reportCommentsForm,
    buttonLoader,
    pagination,
    preloader,
  },
  data () {
    return {
      commentData: [],
      responseData: [],

      query: {
        id: this.$route.params.id,
        page: 1,
        perPage: 6,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created () {
    this.getComments();
  },
  methods: {

    /**
         * Get all comments
         */
    getComments () {
      this.loading = true;

      Api.reports
        .getAllComments(this.query)
        .then((response) => {
          if (response.data.Status) {
            this.commentData = response.data.Data;
            this.responseData = response.data;
          }
          this.loading = false;
        });
    },

    /**
         * Rerender items
         *
         * @param {Number} page
         */
    sendPage (page) {
      this.query.page = page;
      this.getComments();
    },
  },
};
